export enum AlertLabel {
  APPROVAL_REQUIRED = 'account requires approval',
  CARD_ISSUE = 'card issue',
  CARD_LOST = 'card lost',
  CARD_RESTRICTED = 'card restricted',
  CARD_STOLEN = 'card stolen',
  CARD_SUSPENDED = 'card suspended',
  CHANGE_CARD = 'change card',
  CONTACT_BANK = 'contact bank',
  CONTACT_KICKFIN = 'contact kickfin',
  DOLLAR_LIMIT = 'dollar limit',
  EXPIRATION_DATE = 'expiration date',
  EXPIRING_SOON = 'expiring soon',
  FREQUENCY_LIMIT = 'frequency limit',
  INVITE_NOT_ACCEPTED = 'invite pending',
  NO_ACTION = 'no action',
  PAYMENT_LIMIT = 'payment limit',
  UPDATE_CARD = 'update card',
}

export enum AlertType {
  APPROVAL = 'approval',
  CARD = 'card',
  CONTACT = 'contact',
  EXPIRING = 'expiring',
  INVITE_PENDING = 'invite_pending',
}

export interface IAlert {
  label: AlertLabel;
  message: string;
  type: AlertType;
  createdAt: string;
  updatedAt: string;
}
